import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M16 4H4l-4 6v6c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-6l-4-6zM4.535 5h10.93l3.333 5H1.202l3.333-5zM13 12c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-1h6v1zm3-3H4V8h12v1zm-1-2H5V6h10v1z',
  ],
  height: 20,
  width: 20,
});
